import { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";

export const useHeader = () => {
  const navigate = useNavigate();
  const [anchorProfileEl, setAnchorProfileEl] =
    useState<HTMLSpanElement | null>(null);

  useEffect(() => {
    const onWindowClickHandler = (e: MouseEvent) => {
      const profileMenuElm = document.querySelector(".O-Header_ProfileMenu");
      const eventTarget = e.target as unknown as Node;
      if (
        !anchorProfileEl ||
        !profileMenuElm ||
        anchorProfileEl.contains(eventTarget) ||
        profileMenuElm.contains(eventTarget)
      )
        return;
      setAnchorProfileEl(null);
    };

    window.addEventListener("click", onWindowClickHandler);

    return () => {
      window.removeEventListener("click", onWindowClickHandler);
    };
  }, [anchorProfileEl]);

  const handleToggleProfileMenu = (e: React.MouseEvent<HTMLSpanElement>) =>
    setAnchorProfileEl((prevState) => (prevState ? null : e.currentTarget));

  const handleClickProfileMenuItem = (params: {
    path?: string;
    onClick?: () => void;
  }) => {
    const { path, onClick } = params;
    if (path) {
      navigate(path);
    }
    setAnchorProfileEl(null);
    onClick?.();
  };

  return {
    anchorProfileEl,
    handleClickProfileMenuItem,
    handleToggleProfileMenu,
  };
};
